import { CanDeactivateFn } from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { ReviewOrdersPage } from '../../pages/review-orders-page/review-orders-page.component';

/**
 * Waits for the review exit sequence (pending saves + updateCartStatus) before deactivation.
 * Only applies when the page is reached through the routed url; the CMS-rendered url relies on
 * the component's own navigation hook, which the dashboard requests wait for.
 */
export const reviewOrderExitGuard: CanDeactivateFn<ReviewOrdersPage> = (
  component: ReviewOrdersPage
): Observable<boolean> => {
  return component.persistExitState().pipe(
    map(() => true),
    catchError(() => of(true))
  );
};
